import Config from './customers.router';
import options from './customers.component';

const Component = {
    selector: 'dtCustomersView',
    options
};

export {
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/customers/index.js